var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loggedInDetail)?[_c('Customer')]:[_c('Agent',{attrs:{"agentDetails":_vm.loggedInUserDetail}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }